// src/components/customer/blog/BlogCard.jsx
import React from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FiCalendar, FiArrowRight } from "react-icons/fi";
import "../../../assets/css/customer/components/BlogSingleCard.css";
import DOMPurify from "dompurify";

const BlogCard = ({ blog, variant = "default" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/blogs/${blog.slug}`, { state: { blogData: blog } });
  };

  if (variant === "sidebar") {
    return (
      <div className="sidebar-blog-card" onClick={handleClick}>
        <img src={blog.image} alt={blog.title} />
        <span>{blog.title}</span>
      </div>
    );
  }

  if (variant === "home") {
    return (
      <Card className="home-blog-card" onClick={handleClick}>
        <div className="home-blog-image">
          <Card.Img variant="top" src={blog.image} alt={blog.title} />
          {blog.category && (
            <span className="home-blog-category">{blog.category}</span>
          )}
        </div>
        <Card.Body className="home-blog-content">
          <div className="home-blog-date">
            <FiCalendar size={14} />
            <span> {new Date(blog.created_at).toLocaleDateString()}</span>
          </div>
          <Card.Title as="h3">{blog.title}</Card.Title>
          <div
            className="home-blog-excerpt"
            dangerouslySetInnerHTML={{
              __html: blog.content
                ? DOMPurify.sanitize(blog.content)
                : "<p>No content</p>",
            }}
          />
          <button className="home-blog-read-more">
            Read More
            <FiArrowRight size={16} />
          </button>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="blog-card" onClick={handleClick}>
      <div className="blog-card-image">
        <Card.Img
          variant="top"
          src={blog.image}
          alt={blog.title}
          loading="lazy"
        />
        {blog.category && (
          <span className="blog-category-badge">{blog.category}</span>
        )}
      </div>
      <Card.Body className="blog-card-content">
        <Card.Title as="h3">{blog.title}</Card.Title>
        <Card.Text
          as="p"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.content) }}
        />
        <div className="blog-card-meta">
          <div className="meta-left">
            <span>
              <FiCalendar size={12} /> {blog.date}
            </span>
            <span>{blog.readTime}</span>
          </div>
          <button className="read-more-btn">
            Read More <FiArrowRight size={14} />
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BlogCard;
